const SvgSchoolBuildingIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <g clipPath="url(#school_building-icon_svg__a)">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M11.063 2.47a1.5 1.5 0 0 1 1.753-.087l.12.087 4.313 3.45a2 2 0 0 1 .743 1.38l.008.18V19h1v-8.5a.5.5 0 0 1 .41-.492l.09-.007h.5a2 2 0 0 1 1.995 1.85L22 12v7.9a1.1 1.1 0 0 1-.98 1.093L20.9 21H3.1a1.1 1.1 0 0 1-1.094-.98L2 19.9V12a2 2 0 0 1 1.85-1.995L4 10h.5a.5.5 0 0 1 .492.41L5 10.5V19h1V7.48a2 2 0 0 1 .614-1.441l.137-.12zM12 9a2 2 0 1 0 0 4 2 2 0 0 0 0-4"
        clipRule="evenodd"
      />
    </g>
  </svg>
);

export default SvgSchoolBuildingIcon;
